// extracted by mini-css-extract-plugin
module.exports = {"section":"Thanks_section__1PZFV","inApp":"Thanks_inApp__2US4I"};